import React from "react";
import { Box, Typography, TextField } from "@mui/material";

const AddTitle = ({ title, setTitle, label = "Title" }) => {
  return (
    <Box>
      <Typography component="div" className="label">
        {label}
      </Typography>
      <TextField
        className="report-input"
        variant="standard"
        value={title}
        onChange={(event) => setTitle(event.target.value)}
      />
    </Box>
  );
};

export default AddTitle;
